module.exports = __webpack_public_path__ + "static/media/everyday_digital.f2c235ad.png";